export default __webpack_public_path__ + "static/ui-new-logo-31a64a60efd11c82dfeacfd3dd290306.svg";